import { FunctionComponent, memo } from 'react';
import { MentionBlockData, UserMentionPreview } from '../../../../shared';

export const Mention: FunctionComponent<MentionBlockData> = memo(({ mentionedUsers }) => {
  return <UserMentionPreview mentionedUsers={mentionedUsers} openProfile />;
});
